import { Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';
import AnnouncementBar from './AnnouncementBar';
import Navbar from './Navbar';
import Footer from './Footer';
import WhatsAppButton from '../common/WhatsAppButton';
import CustomSections from '../common/CustomSections';
import CartDrawer from '../common/CartDrawer';
import FreeDeliveryCelebration, { useFreeDeliveryUnlock } from '../common/FreeDeliveryCelebration';
import FreeGiftCelebration, { useGiftUnlock } from '../common/FreeGiftCelebration';
import { useCart } from '../../context/CartContext';

function MobileCelebration() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const { cartTotal, freeTiers, freeShippingAbove } = useCart();
  const [celebrate, closeCelebration] = useFreeDeliveryUnlock(cartTotal, freeShippingAbove);
  const [celebrateGift, closeGiftCelebration] = useGiftUnlock(cartTotal, freeTiers);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  if (!isMobile) return null;

  return (
    <>
      {celebrate && <FreeDeliveryCelebration onClose={closeCelebration} />}
      {celebrateGift && <FreeGiftCelebration gift={celebrateGift} onClose={closeGiftCelebration} />}
    </>
  );
}

export default function StoreLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <AnnouncementBar />
      <Navbar />
      <main className="flex-1 pb-16 md:pb-0">
        <Outlet />
      </main>
      <CustomSections />
      <Footer />
      <WhatsAppButton />
      <CartDrawer />
      <MobileCelebration />
    </div>
  );
}
